import React, { useState } from 'react';

import { hooks } from '../hooks';
import { Routes } from '../routes';
import { actions } from '../store/actions';
import { components } from '../components';
import { TabScreens } from '../routes';
import utils from '../helpers/utils';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import foodImage from '../assets/icons/food_order.png';

export const OrderSuccessful: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();
  const location = hooks.useLocation();

  const { promiseDateTime, orderNo, orderId } = location.state || '';

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const selectedSiteId = useSelector(
    (state: RootState) => state.selectedSiteReducer.selectedSiteId
  );
  const allSites = useSelector((state: RootState) => state.screenReducer.sites);
  const orderMode = useSelector(
    (state: RootState) => state.appReducer.orderMode
  );
  const selectedSite =
    selectedSiteId && utils.getSelectedSite(selectedSiteId, allSites);

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container'>
        <section
          style={{
            height: '100%',
            marginTop: 10,
            borderRadius: 10,
            backgroundColor: 'var(--white-color)',
          }}
        >
          <img src={foodImage} alt='Order successful' className='status-img' />
          <h2
            style={{
              textTransform: 'capitalize',
              textAlign: 'center',
              marginBottom: 10,
            }}
          >
            Thank you for your order! <br /> {`order no. :- ${orderNo}`}
          </h2>
          <p
            className='t16'
            style={{ textAlign: 'center', padding: '0px 10px' }}
          >
            {orderMode &&
              selectedSite &&
              utils.getOrderModeMessage(
                orderMode,
                selectedSite.siteName,
                promiseDateTime
              )}
          </p>
        </section>
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return (
      <section style={{ padding: 20 }}>
        <components.Button
          text='Continue Shopping'
          containerStyle={{ marginBottom: 14 }}
          onClick={() => {
            dispatch(actions.resetCart());
            dispatch(actions.setScreen(TabScreens.Home));
            navigate(Routes.TabNavigator);
          }}
        />
        <components.Button
          text='View orders'
          colorScheme='secondary'
          onClick={() =>
            navigate(Routes.OrderSummary, { state: { orderId: orderId } })
          }
        />
      </section>
    );
  };

  return (
    <div id='screen' style={{ opacity }}>
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
